export const CacheKeyNames = {
    legalEntityAssessmentData: 'legalEntityAssessmentData',
    attestationHistoryTable: 'attestationHistoryTable',
};
